export default __webpack_public_path__ + "images/LX.6984742.png";